import { Link } from "react-router-dom";

const footerGroups = [
  {
    title: "Shop",
    links: [
      { label: "Browse catalog", to: "/shop" },
      { label: "Search products", to: "/shop/search" },
      { label: "Cart", to: "/shop/cart" },
      { label: "Projects", to: "/projects" }
    ]
  },
  {
    title: "Business",
    links: [
      { label: "Custom builds", to: "/projects" },
      { label: "Checkout", to: "/shop/checkout" }
    ]
  },
  {
    title: "Support",
    links: [
      { label: "Customer care", to: "/shop/checkout" },
      { label: "Delivery details", to: "/shop/checkout" },
      { label: "Payments", to: "/shop/cart" },
      { label: "Product lookup", to: "/shop/search" }
    ]
  }
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer mt-16">
      <div className="pb-6">
        <div className="footer-hero px-6 py-7 sm:px-8">
          <div className="section-shell flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-cyan-300">Novatech</p>
              <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
                Innovate, Enhance and Sustain.
              </h2>
              <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300">
                Built for customers who need reliable product access and for teams who need catalog, sales, invoicing, and operational control in one system.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link className="brand-button inline-flex rounded-full px-5 py-3 text-sm font-semibold text-white" to="/shop">
                Start shopping
              </Link>
              <Link className="footer-hero__button inline-flex rounded-full px-5 py-3 text-sm font-semibold" to="/shop/search">
                Search products
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-8">
        <div className="footer-shell px-6 py-8 sm:px-8">
          <div className="section-shell grid gap-8 xl:grid-cols-[minmax(0,1.25fr)_minmax(0,0.75fr)_minmax(0,0.75fr)_minmax(0,0.75fr)]">
            <div className="max-w-md">
              <div className="flex items-center gap-3">
                <img alt="Novatech" className="h-12 w-auto object-contain" src="/logo/logo.jpg" />
                <div>
                  <p className="font-display text-2xl font-semibold tracking-tight text-nv-ink">Novatech</p>
                  <p className="text-sm text-nv-slate">Innovate, Enhance and Sustain</p>
                </div>
              </div>

              <div className="mt-6 grid gap-3 text-sm leading-7 text-nv-slate">
                <p>Royal Palms Mall, Mfangano Street</p>
                <p>+254 795 952 128</p>
                <p>info@novatch.co.ke</p>
              </div>


            </div>

            {footerGroups.map((group) => (
              <div key={group.title}>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-nv-slate">{group.title}</p>
                <nav className="mt-5 grid gap-3 text-sm text-nv-ink">
                  {group.links.map((link) => (
                    <Link className="footer-link" key={`${group.title}-${link.label}`} to={link.to}>
                      {link.label}
                    </Link>
                  ))}
                </nav>
              </div>
            ))}
          </div>

          <div className="section-shell mt-8 flex flex-col gap-4 border-t border-black/8 pt-5 text-sm text-nv-slate dark:border-white/8 sm:flex-row sm:items-center sm:justify-between">
            <p>&copy; {year} Novatech.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
